export const ReceiveOrderTypeEnum = {
  NORMAL: '1',
  RETURN: '2',
};

export const ReceiveOrderType = [
  { label: '通常', value: ReceiveOrderTypeEnum.NORMAL },
  { label: '返品', value: ReceiveOrderTypeEnum.RETURN },
];
